import { FC, forwardRef } from "react";
import OtpInput, { OtpInputProps } from "react18-input-otp";

export const PhoneVerificationInput: FC<OtpInputProps> = forwardRef<
  OtpInput,
  OtpInputProps
>((props, ref) => {
  return <OtpInput {...props} ref={ref} />;
});
